export type { PointCardProps } from "./point-card";
export { PointCard } from "./point-card";
